namespace RedBullMOBILE360.PushNotifications {
    @Serenity.Decorators.registerClass()
    export class PushNotificationsExcelImportDialog extends Serenity.PropertyDialog<any, any>  {
        private form: PushNotificationsExcelImportForm;
        public IsDataImported: boolean = false;

        constructor() {
            super();

            this.form = new PushNotificationsExcelImportForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Import Numbers";
        }

        protected getDialogButtons() {
            let buttons = [];
            buttons.push({
                text: 'Send',
                cssClass: 'export-xlsx-button',
                click: () => {
                    if (!this.validateBeforeSave())
                        return;

                    if (this.form.FileName.value == null ||
                        Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                        Q.notifyError("Please select a file!");
                        return;
                    }

                    PushNotificationsService.ExcelImport({
                        FileName: this.form.FileName.value.Filename,
                        SendNow: this.form.SendNow.value,
                        SendDate: this.form.SendDate.value,
                    }, (response) => {
                        let messageParts = new Array<string>();
                        if (response.Inserted > 0) messageParts.push("Message sent successfully");
                        if (response.Updated > 0) messageParts.push("<span style='color: red;'>Failed to send") + "</span>";
                        response.ErrorList.forEach((val) => {
                            messageParts.push(val);
                        });

                        let message: string = messageParts.join(", ");

                        if (response.Inserted > 0) {
                            Q.success(message, () => {
                            }, {
                                htmlEncode: false
                            });
                        }
                        else if (response.Updated > 0) {
                            Q.warning(message,
                                {
                                    htmlEncode: false
                                });
                        } else {
                            Q.information(message, () => {
                            }, {
                                htmlEncode: false
                            });
                        }

                        this.IsDataImported = true;

                        this.dialogClose();
                    });
                },
            });
            buttons.push(
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            );
            return buttons;
        }


    }
}